import React from 'react';
import { useParams } from 'react-router';
import InstructorGradebookContainerWrapper from '../index.jsx';

// Mock function to simulate coming from CW
import {
  getLaunchUrl,
  getStudentReportLink,
} from '@macmillan-learning/gradebook-shared';

const isTrue = (value) => value === 'true';

const InstructorGradebookRoute = () => {
  const {
    courseId,
    courseShortName,
    isSectionManager,
    isGatewayEnabled,
    isRestrictedSection,
  } = useParams();

  const routeProps = {
    courseId,
    courseShortName,
    isSectionManager: isTrue(isSectionManager),
    isGatewayEnabled: isTrue(isGatewayEnabled),
    isRestrictedSection: isTrue(isRestrictedSection),
    getStudentReportLink,
    getLaunchUrl,
  };

  return <InstructorGradebookContainerWrapper {...routeProps} />;
};

export default InstructorGradebookRoute;
